import partialInventory from "./partial-inventory.svg";

export default function PartialInventory({width, height})
{
  return (
    <img src={partialInventory} width={width} height={height}/>
  );
}
